'use strict';
import differenceInMinutes from 'date-fns/difference_in_minutes';
import isDate from 'lodash/isDate';
import isNumber from 'lodash/isNumber';
import moment from 'moment';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/repeatWhen';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeWhile';
import React from 'react';
import {componentFromStream} from 'recompose';
import * as T from 'prop-types';
import {HOUR} from '../../../timers/utils';

export const TimeAgoComponent = componentFromStream(props$ => {
  const timeago$ = props$
    .distinctUntilChanged(null, props => props.date)
    .switchMap(props => {
      const time = parseTime(props.date);
      return useTimeAgo(time, props.cutoff)
        ? timeAgo(props.date, props.format, props.cutoff)
        : Observable.of(renderTime(time, props.format, props.cutoff));
    });

  return props$
    .combineLatest(
      timeago$,
      (props, timeago) => (
        <time
          className={props.className}
          style={props.style}
        >
          {timeago}
        </time>
      )
    );
});

TimeAgoComponent.propTypes = {
  className: T.string,
  style: T.object,
  date: T.oneOfType([
    T.string,
    T.instanceOf(Date),
    T.number,
  ]).isRequired,
  format: T.string,
  cutoff: T.number,
};

TimeAgoComponent.defaultProps = {
  className: '',
  format: 'lll',
  cutoff: 3 * HOUR,
};

function parseTime(date) {
  if (isDate(date)) {
    return moment(date.getTime());
  } else if (isNumber(date)) {
    return moment(date);
  } else {
    return null;
  }
}

/**
 * @param {moment} time
 * @param {Number} cutoff
 * @return {boolean}
 */
function useTimeAgo(time, cutoff) {
  return Math.abs(moment().diff(time)) < cutoff;
}

/**
 * @param {moment} time
 * @param {String} format
 * @param {Number} cutoff
 * @return {String}
 */
function renderTime(time, format, cutoff) {
  if (time === null) {
    return '-';
  } else if (useTimeAgo(time, cutoff)) {
    return time.fromNow();
  } else {
    return time.format(format);
  }
}

function timeAgo(date, format, cutoff) {
  const time = parseTime(date);
  let nextBackoff = 0;
  return Observable.of(true)
    .repeatWhen(emitTrue => emitTrue.delay(nextBackoff))
    .takeWhile(() => nextBackoff !== null)
    .map(() => {
      nextBackoff = backoff(date, cutoff);
      return renderTime(time, format, cutoff);
    });
}

function backoff(milliseconds, cutoff) {
  const minutesElapsed = Math.abs(differenceInMinutes(new Date(), milliseconds));
  let backoffAmountInSeconds;
  if (minutesElapsed < 2) {
    backoffAmountInSeconds = 5;
  } else if (minutesElapsed >= 2 && minutesElapsed < 45) {
    backoffAmountInSeconds = 60;
  } else if (minutesElapsed >= 45 && minutesElapsed < cutoff) {
    backoffAmountInSeconds = 30 * 60;
  } else {
    return null;
  }

  return backoffAmountInSeconds * 1000;
}



// WEBPACK FOOTER //
// ./src/js/components/temporal/TimeAgo/TimeAgoComponent.js